import { AxiosRequestConfig } from "axios";
import { AXIOS_INSTANCE, BASE_URL } from "../App";

export async function getAlertMessageData(salesOrg: any) {
  const config: AxiosRequestConfig = {
    method: "GET",
    params: {
      clientId: "100",
      salesOrg,
    },
    url: `${BASE_URL}/api/sysconfig/alertMessagesData`,
  };

  return await AXIOS_INSTANCE(config)
    .then((v) => v.data)
    .catch((err) => console.error(err));
}

export async function saveAlertMessageData(
  salesOrg:  string,
  fromDate:Date,
  toDate: Date,
  message: string,
) {
  const config: AxiosRequestConfig = {
    method: "POST",
    params: {
      clientId: "100",
      salesOrg,
    },
    data: {
      fromDate: fromDate,
      toDate: toDate,
      message: message
     },
    url: `${BASE_URL}/api/admin/alertMessagesData/save`,
  };

  return await AXIOS_INSTANCE(config)
    .then((v) => v.data)
    .catch((err) => console.error(err));
}

export async function deleteAlertMessage(salesOrg:string,guid:string) {
  const config: AxiosRequestConfig = {
    method: "POST",
    params: {
      clientId: "100",
      salesOrg
    },
    data: {
      guid
    },
    url: `${BASE_URL}/api/admin/alertMessagesData/delete`,
  };

  return await AXIOS_INSTANCE(config)
    .then((v) => v.data)
    .catch((err) => console.error(err));
}

